import React, { useEffect } from 'react';
import SEOLandingTemplate from '@/components/SEOLandingTemplate';

const CyberSecurityTrainingJaipur = () => {
  useEffect(() => {
    document.title = 'Cyber Security Training in Jaipur | Indian Cyber Club Academy';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Professional cybersecurity training in Jaipur with placement support. Learn SOC analysis, VAPT, penetration testing. 340K+ community, 30K+ students trained.');
    }
  }, []);

  const content = [
    "Indian Cyber Club Academy is Jaipur's premier institute for comprehensive cybersecurity training. As cyber threats continue to evolve, the demand for skilled cybersecurity professionals has never been higher. Our training programs are designed to equip you with the knowledge and practical skills needed to excel in this fast-growing field.",
    "Our cybersecurity training in Jaipur covers a wide spectrum of topics including network security, application security, cloud security, incident response, threat intelligence, and security operations. Whether you're looking to start a career in cybersecurity or advance your existing skills, we have programs tailored to your needs.",
    "What makes our cybersecurity training unique is the emphasis on real-world scenarios. You'll work with actual security tools and technologies used by professionals worldwide. Our lab environment simulates real corporate networks, allowing you to practice identifying vulnerabilities, responding to incidents, and implementing security measures.",
    "The training is led by industry experts who bring years of practical experience. They don't just teach theory – they share insights from real security incidents, best practices from enterprise environments, and current trends in the cybersecurity landscape. This practical knowledge is invaluable for your career growth.",
    "We offer both offline training at our Jaipur facility and live online courses for students across India. Our flexible batch timings accommodate working professionals and students alike. With EMI options and special student discounts, quality cybersecurity education is accessible to everyone.",
    "Upon completion of our cybersecurity training, you'll receive an industry-recognized certificate and be prepared for prestigious certifications like CompTIA Security+, CEH, and more. Our placement team works closely with top companies to help you land your dream job in cybersecurity. Join the thousands of successful cybersecurity professionals we've trained."
  ];

  const courseHighlights = [
    { title: "Comprehensive Curriculum", description: "Cover all aspects of cybersecurity from basics to advanced" },
    { title: "Industry-Standard Tools", description: "Master tools used by security professionals worldwide" },
    { title: "Real-World Projects", description: "Work on actual security scenarios and case studies" },
    { title: "Expert Mentorship", description: "Learn from professionals with years of industry experience" },
    { title: "Career Support", description: "Placement assistance with 500+ hiring partners" },
    { title: "Certification Prep", description: "Prepare for CompTIA Security+, CEH, and other certifications" }
  ];

  const keySkills = [
    "Network Security", "Application Security", "Cloud Security", "Incident Response",
    "Threat Intelligence", "Security Operations", "Risk Management", "Compliance",
    "Firewall Configuration", "IDS/IPS", "SIEM", "Vulnerability Management",
    "Security Auditing", "Cryptography", "Access Control", "Security Policies"
  ];

  const faqs = [
    {
      question: "What career opportunities are available after cybersecurity training?",
      answer: "Graduates can pursue roles like Security Analyst, SOC Analyst, Penetration Tester, Security Consultant, Incident Response Analyst, and more. The field offers excellent growth opportunities and competitive salaries."
    },
    {
      question: "Do I need programming knowledge for cybersecurity training?",
      answer: "While programming knowledge is helpful, it's not mandatory. We cover essential scripting and programming concepts as part of the training. However, having basic IT knowledge is recommended."
    },
    {
      question: "How long is the cybersecurity training program?",
      answer: "Our comprehensive cybersecurity training ranges from 3-6 months depending on the program you choose. We offer both intensive bootcamps and regular-paced courses."
    },
    {
      question: "Is the training available online or only offline in Jaipur?",
      answer: "We offer both options! You can attend offline classes at our Jaipur training center or join live online sessions from anywhere in India. Both options provide the same quality instruction."
    },
    {
      question: "What is the average salary after completing cybersecurity training?",
      answer: "Our graduates typically start with packages ranging from 8-15 LPA depending on their background and the role. With experience, cybersecurity professionals can earn significantly higher salaries."
    }
  ];

  return (
    <SEOLandingTemplate
      title="Cyber Security Training"
      subtitle="in Jaipur, Rajasthan"
      metaTitle="Cyber Security Training in Jaipur | Indian Cyber Club Academy"
      metaDescription="Professional cybersecurity training in Jaipur with placement support. Learn SOC analysis, VAPT, penetration testing. 340K+ community, 30K+ students trained."
      content={content}
      courseHighlights={courseHighlights}
      keySkills={keySkills}
      faqs={faqs}
    />
  );
};

export default CyberSecurityTrainingJaipur;